import { Component, Input, OnInit } from '@angular/core';
import { EventInvitation, EventTransaction, TransactionLog, determineLocale } from 'diwimamodelweb/lib';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-transaction-log',
  templateUrl: './transaction-log.component.html',
  styleUrls: ['./transaction-log.component.css']
})
export class TransactionLogComponent implements OnInit {

  @Input() baseItem: EventInvitation|any
  @Input() logItems: TransactionLog[]|EventTransaction[]
  logItems$: Observable<TransactionLog[]|EventTransaction[]>
  locale: string

  constructor(
    
  ) {
    this.locale = determineLocale(navigator.language)
  }

  ngOnInit(): void {
    this.logItems$ = of(this.logItems.sort((a, b) => a.creationDate.getTime() > b.creationDate.getTime() ? -1 : 1))
  }

}
